import { type HTMLAttributes } from 'react';

import { cn } from '@utils/cn';

export type AvatarSize = 'sm' | 'md' | 'lg';

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  name?: string;
  size?: AvatarSize;
  bordered?: boolean;
}

const SIZES: Record<AvatarSize, string> = {
  sm: 'h-[30px] w-[30px] text-[11px]',
  md: 'h-[34px] w-[34px] text-xs',
  lg: 'h-10 w-10 text-sm',
};

export default function Avatar({
  name = '',
  size = 'md',
  className,
  bordered = true,
  ...rest
}: AvatarProps) {
  const initials = name
    .split(' ')
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <span
      title={name}
      className={cn(
        'inline-grid shrink-0 place-items-center rounded-full bg-gradient-to-br from-gold to-[#c87d00] font-display font-bold text-black',
        bordered && 'border-2 border-gold-border',
        SIZES[size],
        className,
      )}
      {...rest}
    >
      {initials || '?'}
    </span>
  );
}
